import Make from './make'

const make = Make('user/')

export const logout = (): void => {
  make.destroyToken()
  window.location.reload()
}

interface UpdateUserProfileSettings {
  publicJobTitle?: string
  telNum?: string
  userName?: string
}

export const updateUserProfile = async (
  data: UpdateUserProfileSettings,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'update-user-profile',
    data,
  })

  if (!req.success) {
    return false
  }

  return true
}

interface UpdateUserEmail {
  email: string
}

export const updateUserEmail = async (
  data: UpdateUserEmail,
): Promise<{
  success: boolean
  error?: string
}> => {
  const { success, res } = await make.put({
    endpoint: 'update-email',
    data,
  })

  if (res.error) {
    return {
      success,
      error: res.error.response.data.error,
    }
  }

  return {
    success,
  }
}

interface UpdateUserName {
  firstname?: string
  lastname?: string
}

export const updateUserName = async (
  data: UpdateUserName,
): Promise<boolean> => {
  const req = await make.put({
    endpoint: 'update-name',
    data,
  })

  if (!req.success) {
    return false
  }

  return true
}
